import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

const PointCoinIcon = ({
    coinSize = "h-3 w-3 md:h-9 md:w-9",
    coinIconSize = "h-1 w-1 md:h-6 md:w-6",
}: {
    coinSize?: string
    coinIconSize?: string
}) => {
    return (
        <div className={
            cn(
                "flex flex-col items-center bg-secondary justify-center rounded-full",
                coinSize
            )
        }>
            <Star className={cn("text-primary", coinIconSize)} />
        </div>
    );
};

export default PointCoinIcon;
